import React, { useEffect, useState } from 'react';
import api from '../services/api';

const AIInterviewConfigAdmin = () => {
  const [config, setConfig] = useState({
    basePrice: 299,
    gstRate: 0.18,
    paidCreditsPerPack: 5,
    freeInterviews: 1
  });
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  const loadConfig = async () => {
    setLoading(true);
    try {
      const response = await api.get('/api/ai-assistant/interview/config');
      setConfig({
        basePrice: response.data.basePrice ?? 299,
        gstRate: response.data.gstRate ?? 0.18,
        paidCreditsPerPack: response.data.paidCreditsPerPack ?? 5,
        freeInterviews: response.data.freeInterviews ?? 1
      });
    } catch (error) {
      console.error('Failed to load AI interview config:', error);
      setMessage('❌ Failed to load AI interview config');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadConfig();
  }, []);

  const handleSave = async () => {
    try {
      setMessage('');
      const payload = {
        basePrice: Number(config.basePrice),
        gstRate: Number(config.gstRate),
        paidCreditsPerPack: Number(config.paidCreditsPerPack),
        freeInterviews: Number(config.freeInterviews)
      };
      await api.put('/api/ai-assistant/interview/config', payload);
      setMessage('✅ AI interview config updated');
    } catch (error) {
      console.error('Failed to update AI interview config:', error);
      setMessage(`❌ ${error.response?.data?.error || 'Failed to update config'}`);
    }
  };

  if (loading) {
    return <div>Loading AI interview config...</div>;
  }

  return (
    <div className="section">
      <h3>🎤 AI Interview Configuration</h3>
      {message && <div style={{ marginBottom: '12px' }}>{message}</div>}
      <div style={{ display: 'grid', gap: '12px', maxWidth: '520px' }}>
        <label>
          Base Price (₹)
          <input
            type="number"
            value={config.basePrice}
            onChange={(e) => setConfig({ ...config, basePrice: e.target.value })}
            style={{ width: '100%', padding: '10px', marginTop: '6px' }}
          />
        </label>
        <label>
          GST Rate (e.g. 0.18)
          <input
            type="number"
            step="0.01"
            value={config.gstRate}
            onChange={(e) => setConfig({ ...config, gstRate: e.target.value })}
            style={{ width: '100%', padding: '10px', marginTop: '6px' }}
          />
        </label>
        <label>
          Paid Credits Per Pack
          <input
            type="number"
            value={config.paidCreditsPerPack}
            onChange={(e) => setConfig({ ...config, paidCreditsPerPack: e.target.value })}
            style={{ width: '100%', padding: '10px', marginTop: '6px' }}
          />
        </label>
        <label>
          Free AI Interviews Per User
          <input
            type="number"
            value={config.freeInterviews}
            onChange={(e) => setConfig({ ...config, freeInterviews: e.target.value })}
            style={{ width: '100%', padding: '10px', marginTop: '6px' }}
          />
        </label>
        <button
          onClick={handleSave}
          className="approve-btn"
          style={{ width: 'fit-content' }}
        >
          Save Configuration
        </button>
      </div>
    </div>
  );
};

export default AIInterviewConfigAdmin;
